import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { EmbeddedProductConfiguratorPageInitialData } from "./embeddedProductConfiguratorPageInitialData";

function buildEmbeddedConfiguratorPath(productCode: string, token: string | null) {
  const encodedProductCode = encodeURIComponent(productCode);
  const base = `/page-data/embeddedProductConfigurator/${encodedProductCode}`;
  return token == null || token === "" ? base : `${base}?token=${encodeURIComponent(token)}`;
}

export function embeddedConfiguratorPageQueryOptions(productCode: string, token: string | null) {
  return queryOptions({
    queryKey: pageDataKeys.embeddedProductConfigurator(productCode, token),
    queryFn: () =>
      fetchOccPageData<PageInitialDataResult<EmbeddedProductConfiguratorPageInitialData>>(
        buildEmbeddedConfiguratorPath(productCode, token),
      ),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
}
